import {Action, Dispatch} from 'redux';
import {showMessage} from './Common';
import {showError} from './Common';
import {ApiActionCall, ApiActionTypes} from './Api';
import {CommonActionTypes} from '../../types/actions/Common.action';
import {
  PRICE_INCREASE_URL,
  NEXT_PRICE_INCREASE_URL,
} from '../../@crema/services/ApiConfig';
import {
  IPriceIncrease,
  INextPriceIncrease,
  IAddBuyPrice,
} from '../../types/models/Price';
import {
  FETCH_PRICE_INCREASE,
  FETCH_PRICE_INCREASE_ERROR,
  FETCH_PRICE_INCREASE_SUCCESS,
  PriceIncreaseActionTypes,
  SAVE_PRICE_INCREASE,
  SAVE_PRICE_INCREASE_ERROR,
  SAVE_PRICE_INCREASE_SUCCESS,
  FETCH_NEXT_PRICE_INCREASE,
  FETCH_NEXT_PRICE_INCREASE_ERROR,
  FETCH_NEXT_PRICE_INCREASE_SUCCESS,
  ADD_BUY_PRICE,
  ADD_BUY_PRICE_SUCCESS,
  ADD_BUY_PRICE_ERROR,
} from '../../types/actions/PriceIncrease.actions';
import {logger} from '../../shared/logger';

export const savePriceIncrease = (
  cronTimeInterval: string,
  percentage: number,
) => async (
  dispatch: Dispatch<
    ApiActionCall | CommonActionTypes | PriceIncreaseActionTypes
  >,
) => {
  dispatch({type: SAVE_PRICE_INCREASE});
  const onSuccess = (payload: IPriceIncrease) => (
    dispatch: Dispatch<any>,
  ) => {
    dispatch(showMessage('Successfully saved'));
    dispatch({
      type: SAVE_PRICE_INCREASE_SUCCESS,
      payload,
    });
    dispatch(fetchPriceIncrease());
    dispatch(fetchNextPriceIncrease());
  };
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    dispatch({type: SAVE_PRICE_INCREASE_ERROR});
    dispatch(showError(message));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: NEXT_PRICE_INCREASE_URL,
      method: 'PUT',
      data: {
        cronTimeInterval,
        percentage,
      },
      label: 'Save price increase',
      onSuccess,
      onFailure,
    },
  });
};

export const addBuyPrice = (buyPrice: number) => async (
  dispatch: Dispatch<
    ApiActionCall | CommonActionTypes | PriceIncreaseActionTypes
  >,
) => {
  dispatch({type: ADD_BUY_PRICE});

  const onSuccess = (payload: IAddBuyPrice) => (dispatch: Dispatch<any>) => {
    dispatch(showMessage('Successfully saved'));
    dispatch({
      type: ADD_BUY_PRICE_SUCCESS,
      payload,
    });
    dispatch(fetchPriceIncrease());
    dispatch(fetchNextPriceIncrease());
  };

  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    dispatch({type: ADD_BUY_PRICE_ERROR});
    dispatch(showError(message));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: PRICE_INCREASE_URL,
      method: 'PUT',
      data: {
        buyPrice,
      },
      label: 'Add buy price',
      onSuccess,
      onFailure,
    },
  });
};

export const fetchPriceIncrease = () => async (
  dispatch: Dispatch<ApiActionCall | PriceIncreaseActionTypes>,
) => {
  dispatch({type: FETCH_PRICE_INCREASE});

  const onSuccess = (payload: IPriceIncrease) => ({
    type: FETCH_PRICE_INCREASE_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_PRICE_INCREASE_ERROR});
    dispatch(showError('Failed to fetch price increase data.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: PRICE_INCREASE_URL,
      method: 'GET',
      label: 'Fetch price increase',
      onSuccess,
      onFailure,
    },
  });
};

export const fetchNextPriceIncrease = () => async (
  dispatch: Dispatch<ApiActionCall | PriceIncreaseActionTypes>,
) => {
  dispatch({type: FETCH_NEXT_PRICE_INCREASE});

  const onSuccess = (payload: INextPriceIncrease) => ({
    type: FETCH_NEXT_PRICE_INCREASE_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_NEXT_PRICE_INCREASE_ERROR});
    dispatch(showError('Failed to fetch next price increase data.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: NEXT_PRICE_INCREASE_URL,
      method: 'GET',
      label: 'Fetch next price increase',
      onSuccess,
      onFailure,
    },
  });
};
